// AUTO-GENERATED from scripts/figma/Semantic_Tokens.json
// Run `yarn codegen-design-system` to regenerate. Do not edit by hand.
// Allow importing from primitives in this file
// eslint-disable-next-line import/no-restricted-paths, no-restricted-imports
import { primitives } from './color.primitive';

const c = primitives.color;

export const color = {
    background: {
        scrim: c.neutral.alpha[60],
        neutral: {
            base: c.neutral[950],
            subtler: c.neutral[900],
            subtle: c.neutral[800],
            strong: c.neutral[700],
            stronger: c.neutral[600],
            inverse: c.neutral[100],
        },
        transparent: {
            subtle: c.neutral.alpha[15],
            strong: c.neutral.alpha[20],
        },
        brand: {
            subtle: c.purple[950],
            strong: c.purple[700],
            emphasis: c.purple[600],
        },
        danger: {
            subtle: c.red[950],
            strong: c.rose[600],
        },
        warning: {
            subtle: c.orange[950],
            strong: c.orange[500],
        },
        success: {
            subtle: c.green[950],
            strong: c.green[600],
        },
        information: {
            subtle: c.purple[950],
            strong: c.purple[700],
        },
        discovery: {
            subtle: c.blue[950],
            strong: c.blue[500],
        },
        pickType: {
            boost: {
                subtle: c.yellow[950],
                strong: c.yellow[300],
            },
            edge: {
                subtle: c.blue[950],
                strong: c.blue[500],
            },
            discount: {
                subtle: c.cyan[950],
                strong: c.cyan[400],
            },
            freePick: {
                subtle: c.cyan[950],
                strong: c.cyan[400],
            },
            surge: {
                subtle: c.pink[950],
                strong: c.pink[500],
            },
            nuke: {
                subtle: c.yellow[950],
                strong: c.yellow[300],
            },
            anchor: {
                subtle: c.neutral[900],
                strong: c.neutral[100],
            },
        },
        accent: {
            red: {
                strong: c.red[500],
                subtle: c.red[950],
            },
            orange: {
                subtle: c.orange[950],
                strong: c.orange[500],
            },
            amber: {
                subtle: c.amber[950],
                strong: c.amber[400],
            },
            yellow: {
                subtle: c.yellow[950],
                strong: c.yellow[300],
            },
            lime: {
                subtle: c.lime[950],
                strong: c.lime[500],
            },
            green: {
                subtle: c.green[950],
                strong: c.green[600],
            },
            emerald: {
                subtle: c.emerald[950],
                strong: c.emerald[500],
            },
            teal: {
                subtle: c.teal[950],
                strong: c.teal[400],
            },
            cyan: {
                subtle: c.cyan[950],
                strong: c.cyan[400],
            },
            sky: {
                subtle: c.sky[950],
                strong: c.sky[400],
            },
            blue: {
                subtle: c.blue[950],
                strong: c.blue[500],
            },
            indigo: {
                subtle: c.indigo[950],
                strong: c.indigo[500],
            },
            violet: {
                subtle: c.violet[950],
                strong: c.violet[500],
            },
            purple: {
                subtle: c.purple[950],
                strong: c.purple[500],
            },
            fuchsia: {
                subtle: c.fuchsia[950],
                strong: c.fuchsia[500],
            },
            pink: {
                subtle: c.pink[950],
                strong: c.pink[500],
            },
            rose: {
                subtle: c.rose[950],
                strong: c.rose[600],
            },
        },
    },
    text: {
        primary: c.neutral[100],
        secondary: c.neutral[500],
        tertiary: c.neutral[600],
        disabled: c.neutral[700],
        inverse: c.neutral[950],
        brand: c.purple[400],
        brandoninverse: c.purple[600],
        danger: c.rose[600],
        warning: c.orange[600],
        success: c.green[600],
        discovery: c.blue[500],
        information: c.purple[500],
        pickType: {
            boost: c.yellow[300],
            edge: c.blue[500],
            discount: c.cyan[400],
            freePick: c.cyan[400],
            surge: c.pink[500],
            nuke: c.yellow[300],
            anchor: c.neutral[100],
        },
        accent: {
            amber: c.amber[400],
            red: c.red[600],
            orange: c.orange[600],
            yellow: c.yellow[300],
            lime: c.lime[500],
            green: c.green[600],
            emerald: c.emerald[600],
            teal: c.teal[500],
            cyan: c.cyan[500],
            sky: c.sky[500],
            blue: c.blue[500],
            indigo: c.indigo[500],
            violet: c.violet[500],
            purple: c.purple[500],
            fuchsia: c.fuchsia[600],
            pink: c.pink[600],
            rose: c.rose[600],
        },
    },
    icon: {
        primary: c.neutral[100],
        secondary: c.neutral[500],
        tertiary: c.neutral[600],
        disabled: c.neutral[700],
        inverse: c.neutral[950],
        brand: c.purple[400],
        danger: c.rose[600],
        warning: c.orange[600],
        success: c.green[600],
        discovery: c.blue[500],
        information: c.purple[500],
        pickType: {
            boost: c.yellow[300],
            edge: c.blue[500],
            discount: c.cyan[400],
            freePick: c.cyan[400],
            surge: c.pink[500],
            nuke: c.yellow[300],
            anchor: c.neutral[100],
        },
        accent: {
            amber: c.amber[400],
            red: c.red[600],
            orange: c.orange[600],
            yellow: c.yellow[300],
            lime: c.lime[500],
            green: c.green[600],
            emerald: c.emerald[600],
            teal: c.teal[500],
            cyan: c.cyan[500],
            sky: c.sky[500],
            blue: c.blue[500],
            indigo: c.indigo[500],
            violet: c.violet[500],
            purple: c.purple[500],
            fuchsia: c.fuchsia[600],
            pink: c.pink[600],
            rose: c.rose[600],
        },
    },
    border: {
        subtle: c.neutral.alpha[1],
        strong: c.neutral.alpha[3],
    },
} as const;
